import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { useAppForm } from "@/hooks/form";
import { BBBackendClient } from "@bidbattles/bloks/lib/rapace";
import { toast } from "sonner";
import { m } from "@/paraglide/messages";

export const Route = createFileRoute("/settings/password")({
	component: RouteComponent,
});

const updatePasswordSchema = z
	.object({
		current_password: z.string(),
		new_password: z.string(),
		confirm_new_password: z.string(),
	})
	.refine(
		({ new_password, confirm_new_password }) =>
			new_password == confirm_new_password,
		{
			error: "New password & new password confirmation are not equal",
			path: ["confirm_new_password"],
		},
	);

export function ChangePasswordForm() {
	const form = useAppForm({
		defaultValues: {
			current_password: "",
			new_password: "",
			confirm_new_password: "",
		},
		validators: {
			onChange: updatePasswordSchema,
			onBlur: updatePasswordSchema,
			onSubmit: updatePasswordSchema,
		},
		async onSubmit({ value, formApi }) {
			const result = await BBBackendClient.updatePassword(value);
			if (!result.ok) {
				toast.error(m.error_toast({ message: result.error.message }));
				return;
			}

			formApi.reset();
			toast.success("Password changed successfully.");
		},
	});

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				form.handleSubmit();
			}}
			className="flex flex-col gap-5"
		>
			<form.AppField name="current_password">
				{(field) => (
					<form.FormLabelledRow label="Current password">
						{({ id }) => (
							<field.TextField id={id} variant="box" type="password" />
						)}
					</form.FormLabelledRow>
				)}
			</form.AppField>
			<form.AppField name="new_password">
				{(field) => (
					<form.FormLabelledRow label="New password">
						{({ id }) => (
							<field.TextField id={id} variant="box" type="password" />
						)}
					</form.FormLabelledRow>
				)}
			</form.AppField>
			<form.AppField name="confirm_new_password">
				{(field) => (
					<form.FormLabelledRow label="Confirm new password">
						{({ id }) => (
							<field.TextField id={id} variant="box" type="password" />
						)}
					</form.FormLabelledRow>
				)}
			</form.AppField>
			<div className="ms-auto mt-4 inline-flex gap-4">
				<form.AppForm>
					<form.ResetButton label="Cancel" />
					<form.SubscribeButton label="Update password" />
				</form.AppForm>
			</div>
		</form>
	);
}

function RouteComponent() {
	return <ChangePasswordForm />;
}
